import { animateScroll as scroll, scroller } from 'react-scroll'

export const scrollToElement = (elementID, offset) => {
    if (! elementID) {
        return scroll.scrollToTop()
    }

    let options = {
        duration: 500,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -60,
    }

    if (offset !== undefined) {
        options.offset = offset
    }

    return scroller.scrollTo(elementID, options)
}